import styled from 'styled-components';

export const Content = styled.main({
  minHeight: 'calc(100vh - 200px)',
});
